import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import routes from "routes";
const PopupLogout = (props) => {
  const location = useLocation();

  const [active, setActive] = useState(null);
  const [namePage, setNamePage] = useState("Home");
  const navigate = useNavigate();
  
  const handleNavigate = (e) => {
    if (e === location?.pathname) {
      props.handleCloseNav();
    }
    navigate(e);
  };

  return (
    <>
      <div className="popup-overlay modal-top move">
        <div className="popup-warp">
          <div className="popup-inner">
            <div className="content-popup">
              <ul>
                {routes.map((link, index) => {
                  return (
                    <>
                      {link.path !== "/thongtinnguoidung" &&
                        link.path !== "/game" &&
                        link.path !== "/pc" && (
                          <>
                            <li key={index} className="nav-item">
                              <a
                                // href={`#${link.path}`}
                                className={`nav-link ${active == link.path && "active"
                                  }`}
                                onClick={() => {
                                  setActive(link.path);
                                  setNamePage(link.name);
                                  handleNavigate(link.path);
                                }}
                              >
                                {link.name}
                              </a>
                            </li>
                          </>
                        )}
                    </>
                  );
                })}
              </ul>
            </div>
          </div>
          <div className="close-nav" onClick={props.handleCloseNav}></div>
        </div>
      </div>
    </>
  );
};
export default PopupLogout;
